<template>
  <div>
    <v-container fluid class="d-print-none">
      <v-row>
        <v-col cols="12" sm="6">
          <v-form method="post" id="nativeForm" v-model="valid">
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <h3>Export Report</h3>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      :items="date_type"
                      v-model="form_search.date_type"
                      menu-props="auto"
                      label="Select Date Type"
                      hide-details
                      :rules="date_typeR"
                      @change="change_date_type()"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="
                      form_search.date_type != null &&
                      form_search.date_type != 'pending'
                    "
                  >
                    <v-menu
                      v-model="modal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Date range"
                          readonly
                          v-on="on"
                          :rules="dateR"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        style="min-width: 0px !important"
                        v-model="form_search.dates"
                        range
                        @change="get_date(1)"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" v-if="data_filter.project != null">
                    <v-autocomplete
                      chips
                      v-model="form_search.project"
                      :items="data_filter.project"
                      label="Select Project"
                      item-text="project_name"
                      item-value="project_id"
                      multiple
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.project_name }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{ form_search.project.length - 1 }} others)</span
                        >
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle">
                          <v-list-item-action>
                            <v-icon
                              :color="
                                form_search.project.length > 0
                                  ? 'indigo darken-4'
                                  : ''
                              "
                              >{{ icon }}</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      <!--  -->

                      <template v-slot:append-item>
                        <v-divider class="mb-2"></v-divider>
                        <v-list-item disabled>
                          <v-list-item-avatar color="grey lighten-3">
                            <v-icon>mdi-folder-plus</v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content v-if="likesAllProject">
                            <v-list-item-title
                              >Select All Project</v-list-item-title
                            >
                          </v-list-item-content>

                          <v-list-item-content v-else-if="likesSomeProject">
                            <v-list-item-title>Project Count</v-list-item-title>
                            <v-list-item-subtitle>{{
                              form_search.project.length
                            }}</v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-content v-else> </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    v-if="data_filter.zone != null"
                    cols="12"
                    :class="
                      form_search.date_type != null &&
                      form_search.date_type != 'pending'
                        ? ''
                        : 'mar-t-20'
                    "
                  >
                    <v-autocomplete
                      chips
                      v-model="form_search.zone"
                      :items="data_filter.zone"
                      label="Select Zone"
                      item-text="branch_name"
                      item-value="branch_id"
                      multiple
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.branch_name }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{ form_search.zone.length - 1 }} others)</span
                        >
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle_zone">
                          <v-list-item-action>
                            <v-icon
                              :color="
                                form_search.zone.length > 0
                                  ? 'indigo darken-4'
                                  : ''
                              "
                              >{{ icon_zone }}</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2"></v-divider>
                        <v-list-item disabled>
                          <v-list-item-avatar color="grey lighten-3">
                            <v-icon>mdi-folder-plus</v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content v-if="likesAllZone">
                            <v-list-item-title
                              >Select All Zone</v-list-item-title
                            >
                          </v-list-item-content>

                          <v-list-item-content v-else-if="likesSomeZone">
                            <v-list-item-title>Zone Count</v-list-item-title>
                            <v-list-item-subtitle>{{
                              form_search.zone.length
                            }}</v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-content v-else> </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" v-if="data_filter.team">
                    <v-autocomplete
                      chips
                      v-model="form_search.team"
                      :items="data_filter.team"
                      label="Select team"
                      item-text="team_name"
                      item-value="team_id"
                      multiple
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.team_name }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{ form_search.team.length - 1 }} others)</span
                        >
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle_team">
                          <v-list-item-action>
                            <v-icon
                              :color="
                                form_search.team.length > 0
                                  ? 'indigo darken-4'
                                  : ''
                              "
                              >{{ icon_team }}</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2"></v-divider>
                        <v-list-item disabled>
                          <v-list-item-avatar color="grey lighten-3">
                            <v-icon>mdi-folder-plus</v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content v-if="likesAllTeam">
                            <v-list-item-title
                              >Select All team</v-list-item-title
                            >
                          </v-list-item-content>

                          <v-list-item-content v-else-if="likesSomeTeam">
                            <v-list-item-title>team Count</v-list-item-title>
                            <v-list-item-subtitle>{{
                              form_search.team.length
                            }}</v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-content v-else> </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="3">
                    <v-chip small color="teal accent-3"> Sub </v-chip>
                  </v-col>
                  <v-col cols="12" sm="9" class="mar-t-20">
                    <v-radio-group
                      v-model="form_search.sub_type"
                      row
                      :rules="sub_typeR"
                    >
                      <v-radio label="All Sub" value="all sub"></v-radio>
                      <v-radio label="Last Sub" value="last sub"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" sm="3" class="mar-t-10">
                    <v-chip small color="teal accent-3"> Layout </v-chip>
                  </v-col>
                  <v-col cols="12" sm="9" class="mar-t-30">
                    <v-radio-group v-model="form_search.layout" row>
                      <v-radio
                        v-if="team_name === 'ODM'"
                        label="ODM"
                        value="odm"
                      ></v-radio>
                      <v-radio label="Raw" value="raw"></v-radio>
                      <v-radio label="Timeline" value="Timeline"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12">
                    <v-progress-linear
                      v-if="chk_export === true"
                      indeterminate
                      color="cyan"
                    ></v-progress-linear>
                    <v-btn
                      v-if="chk_export === false"
                      block
                      color="green accent-3"
                      class="mt-4"
                      @click="export_data(1)"
                      :disabled="
                        !valid ||
                        form_search.project == null ||
                        form_search.zone == null
                      "
                    >
                      Export Data
                    </v-btn>
                    <v-btn block class="mt-3" @click="refresh_data(1)"
                      >Refresh</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-form>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          v-if="
            team_name == 'ODM' || team_name == 'FINANCE' || emp_id == 'P06-297'
          "
        >
          <v-form method="post" id="nativeForm" v-model="valid3">
            <!-- max-width="500" -->
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <h3>Export Quote Report</h3>
                  </v-col>
                  <v-col cols="12">
                    <v-menu
                      v-model="modal7"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateRangeText7"
                          label="Date range"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        style="min-width: 0px !important"
                        v-model="form_quote.date"
                        range
                        @change="get_date(7)"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" class="mar-t-10">
                    <v-autocomplete
                      :items="['Quote', 'Receipt']"
                      v-model="form_quote.type"
                      label="Select  Type"
                      hide-details
                      :rules="typeR"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <v-progress-linear
                      v-if="chk_export7 === true"
                      indeterminate
                      color="cyan"
                    ></v-progress-linear>
                    <v-btn
                      v-if="chk_export7 === false"
                      block
                      color="green accent-3"
                      class="mt-4"
                      @click="export_data(7)"
                    >
                      Export Data
                    </v-btn>
                    <v-btn block class="mt-3" @click="refresh_data(7)"
                      >Refresh</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-form>
        </v-col>

        <v-col cols="12" sm="6">
          <v-form method="post" id="nativeForm" v-model="valid2">
            <!-- max-width="500" -->
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <h3>Match Case</h3>
                  </v-col>
                  <v-col cols="11">
                    <v-textarea
                      outlined
                      class="ma-1 pa-3"
                      label="Case ID"
                      v-model="form_search.caseid"
                      :rules="caseidR"
                      required
                      rows="10"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" style="margin-top: -46px">
                    <v-progress-linear
                      v-if="chk_export2 === true"
                      indeterminate
                      color="cyan"
                    ></v-progress-linear>
                    <v-btn
                      v-if="chk_export2 === false"
                      block
                      color="green accent-3"
                      class="mt-4"
                      @click="export_data(2)"
                      :disabled="!valid2"
                    >
                      Export Data
                    </v-btn>
                    <v-btn block class="mt-3" @click="refresh_data(2)"
                      >Refresh</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-form>
        </v-col>
        <v-col cols="12" sm="6"  v-if="emp_id == 'P03-177' || emp_id == 'P15-053' ||emp_id == 'A20-001' || emp_id == 'A17-003' ">
          <v-form method="post" v-model="loan.loan_validate">
            <!-- max-width="500" -->
            <v-card>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <h3 >Export Report Part Loan</h3>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" md="12" sm="6">
                      <v-menu
                        v-model="modal8"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        :nudge-width="260"
                        persistent
                      >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateRangeText8"
                          label="Date range"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="loan.date"
                        range
                        @change="get_date(8)"
                      ></v-date-picker>
                    </v-menu>
                      </v-col>
                      <v-col cols="12" md="12" align="center">
                        <v-autocomplete v-model="loan.status" require :items="items_loan" :rules="option_loanR" label="Status"/>
                      </v-col>
                    </v-row>
                  </v-col>
                
                  <v-col cols="12" style="margin-top: -46px">
                    <v-progress-linear
                      v-if="chk_export8 === true"
                      indeterminate
                      color="cyan"
                    ></v-progress-linear>
                    <v-btn
                      block
                      color="green accent-3"
                      class="mt-4"
                      @click="export_data(8)"
                      :disabled = "!loan.loan_validate"
                     
                    >
                      Export Data
                    </v-btn>
                    <v-btn block class="mt-3" 
                      >Refresh</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-form>
        </v-col>
        <v-col cols="12" sm="6" v-if="team_name == 'ODM'">
          <v-form method="post" id="nativeForm" v-model="valid3">
            <!-- max-width="500" -->
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <h3>Warranty Report</h3>
                  </v-col>
                  <v-col cols="12">
                    <v-dialog
                      ref="dialog"
                      v-model="modal_odm"
                      :return-value.sync="form_odem.date"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="form_odem.date"
                          label="Date"
                          prepend-icon=""
                          readonly
                          v-on="on"
                          :rules="date_odmR"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="form_odem.date" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal_odm = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(form_odem.date)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols="12" class="mar-t-10">
                    <v-autocomplete
                      :items="type"
                      v-model="form_odem.type"
                      item-text="name"
                      item-value="id"
                      menu-props="auto"
                      label="Select Date Type"
                      hide-details
                      :rules="typeR"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <v-progress-linear
                      v-if="chk_export3 === true"
                      indeterminate
                      color="cyan"
                    ></v-progress-linear>
                    <v-btn
                      v-if="chk_export3 === false"
                      block
                      color="green accent-3"
                      class="mt-4"
                      @click="export_data(3)"
                      :disabled="!valid3"
                    >
                      Export Data
                    </v-btn>
                    <v-btn block class="mt-3" @click="refresh_data(3)"
                      >Refresh</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-form>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          v-if="team_name == 'SUPPORTUC' || team_name == 'PSG'"
        >
          <v-form method="post" id="nativeForm" v-model="valid4">
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <h3>Admin Informed Report</h3>
                  </v-col>
                  <v-col cols="12">
                    <v-menu
                      v-model="modal4"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateRangeText4"
                          label="Date range"
                          readonly
                          v-on="on"
                          :rules="dateR"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        style="min-width: 0px !important"
                        v-model="form_search.dates4"
                        range
                        @change="get_date(4)"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12">
                    <v-progress-linear
                      v-if="chk_export4 === true"
                      indeterminate
                      color="cyan"
                    ></v-progress-linear>
                    <v-btn
                      v-if="chk_export4 === false"
                      block
                      color="green accent-3"
                      class="mt-4"
                      @click="export_data(4)"
                      :disabled="!valid4"
                    >
                      Export Data
                    </v-btn>
                    <v-btn block class="mt-3" @click="refresh_data(4)"
                      >Refresh</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-form>
        </v-col>
        <v-col cols="12" sm="6" v-if="team_name == 'SUPPORTUC'">
          <v-form method="post" id="nativeForm" v-model="valid5">
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <h3>UEFI Report</h3>
                  </v-col>
                  <v-col cols="12">
                    <v-menu
                      v-model="modal5"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateRangeText5"
                          label="Date range"
                          readonly
                          v-on="on"
                          :rules="dateR"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        style="min-width: 0px !important"
                        v-model="form_search.dates5"
                        range
                        @change="get_date(5)"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12">
                    <v-progress-linear
                      v-if="chk_export5 === true"
                      indeterminate
                      color="cyan"
                    ></v-progress-linear>
                    <v-btn
                      v-if="chk_export5 === false"
                      block
                      color="green accent-3"
                      class="mt-4"
                      @click="export_data(5)"
                      :disabled="!valid5"
                    >
                      Export Data
                    </v-btn>
                    <v-btn block class="mt-3" @click="refresh_data(5)"
                      >Refresh</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-form>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          v-if="team_name == 'SVC' && role_name == 'Manager'"
        >
          <v-form method="post" id="nativeForm" v-model="valid6">
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <h3>Claimed PHA Report</h3>
                  </v-col>
                  <v-col cols="12">
                    <v-menu
                      v-model="modal6"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateRangeText6"
                          label="Date range"
                          readonly
                          v-on="on"
                          :rules="dateR"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        style="min-width: 0px !important"
                        v-model="form_search.dates6"
                        range
                        @change="get_date(6)"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12">
                    <v-progress-linear
                      v-if="chk_export6 === true"
                      indeterminate
                      color="cyan"
                    ></v-progress-linear>
                    <v-btn
                      v-if="chk_export6 === false"
                      block
                      color="green accent-3"
                      class="mt-4"
                      @click="export_data(6)"
                      :disabled="!valid6"
                    >
                      Export Data
                    </v-btn>
                    <v-btn block class="mt-3" @click="refresh_data(6)"
                      >Refresh</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";

const url = `${process.env.VUE_APP_ROOT_API}/api/`;
import { mapState, mapMutations } from "vuex";

export default {
  beforeMount() {
    this.tk = {
      headers: { Authorization: "Bearer " + localStorage.token },
    };
    this.get_filter();
  },
  mounted() {
    // console.log(this.form_search.date_type)
  },
  computed: {
    ...mapState(["isLoading"]),
    likesAllProject() {
      return (
        this.form_search.project.length === this.data_filter.project.length
      );
    },
    likesSomeProject() {
      return this.form_search.project.length > 0 && !this.likesAllProject;
    },
    icon() {
      if (this.likesAllProject) return "mdi-close-box";
      if (this.likesSomeProject) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    likesAllZone() {
      return this.form_search.zone.length === this.data_filter.zone.length;
    },
    likesSomeZone() {
      return this.form_search.zone.length > 0 && !this.likesAllZone;
    },
    icon_zone() {
      if (this.likesAllZone) return "mdi-close-box";
      if (this.likesSomeZone) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    likesAllTeam() {
      return this.form_search.team.length === this.data_filter.team.length;
    },
    likesSomeTeam() {
      return this.form_search.team.length > 0 && !this.likesAllTeam;
    },
    icon_team() {
      if (this.likesAllTeam) return "mdi-close-box";
      if (this.likesSomeTeam) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    dateRangeText() {
      this.form_search.dates.sort((a, b) => {
        return new Date(a) - new Date(b);
      });

      return this.form_search.dates.join(" ~ ");
    },
    dateRangeText4() {
      this.form_search.dates4.sort((a, b) => {
        return new Date(a) - new Date(b);
      });

      return this.form_search.dates4.join(" ~ ");
    },
    dateRangeText5() {
      this.form_search.dates5.sort((a, b) => {
        return new Date(a) - new Date(b);
      });

      return this.form_search.dates5.join(" ~ ");
    },
    dateRangeText6() {
      this.form_search.dates6.sort((a, b) => {
        return new Date(a) - new Date(b);
      });

      return this.form_search.dates6.join(" ~ ");
    },
    dateRangeText7() {
      this.form_quote.date.sort((a, b) => {
        return new Date(a) - new Date(b);
      });

      return this.form_quote.date.join(" ~ ");
    },
    dateRangeText8() {
      this.loan.date.sort((a, b) => {
        return new Date(a) - new Date(b);
      });

      return this.loan.date.join(" ~ ");
    },
  },
  methods: {
    ...mapMutations(["mutateIsLoading"]),
    async get_filter() {
      this.mutateIsLoading();
      await axios.get(url + "report/filter", this.tk).then((response) => {
        console.log(response.data);
        this.data_filter.project = response.data.project;
        this.data_filter.zone = response.data.zone;
        this.data_filter.team = response.data.team;
        this.mutateIsLoading();
      });
    },
    get_date(st) {
      if (st == 1) {
        if (this.dateRangeText.length === 23) {
          this.modal = false;
        }
      } else if (st == 4) {
        if (this.dateRangeText4.length === 23) {
          this.modal4 = false;
        }
      } else if (st == 5) {
        if (this.dateRangeText5.length === 23) {
          this.modal5 = false;
        }
      } else if (st == 6) {
        if (this.dateRangeText6.length === 23) {
          this.modal6 = false;
        }
      } else if (st == 7) {
        if (this.dateRangeText7.length === 23) {
          this.modal7 = false;
        }
      }else if (st == 8) {
        if (this.dateRangeText8.length === 23) {
          this.modal8 = false;
          // this.loan.loan_validate = true
        }
      }
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllProject) {
          this.form_search.project = [];
        } else {
          // this.form_search.project = this.data_filter.project.slice()
          this.form_search.project = [];
          this.data_filter.project.map((each) => {
            this.form_search.project.push(each.project_id);
          });
        }
      });
    },
    toggle_zone() {
      this.$nextTick(() => {
        if (this.likesAllZone) {
          this.form_search.zone = [];
        } else {
          // this.form_search.zone = this.data_filter.zone.slice()
          this.form_search.zone = [];
          this.data_filter.zone.map((each) => {
            this.form_search.zone.push(each.branch_id);
          });
        }
      });
    },
    toggle_team() {
      this.$nextTick(() => {
        if (this.likesAllTeam) {
          this.form_search.team = [];
        } else {
          // this.form_search.team = this.data_filter.team.slice()
          this.form_search.team = [];
          this.data_filter.team.map((each) => {
            this.form_search.team.push(each.team_id);
          });
        }
      });
    },
    async export_data(st) {
      let url_report;
      let data_export;
      if (st == 1) {
        this.chk_export = true;
        url_report = "report/data";
        data_export = this.form_search;
      } else if (st == 2) {
        this.chk_export2 = true;
        url_report = "report/data";
        data_export = this.form_search;
      } else if (st == 3) {
        this.chk_export3 = true;
        url_report = "report/odm-warranty-report";
        data_export = this.form_odem;
      } else if (st == 4) {
        this.chk_export4 = true;
        url_report = "report/admin-informed";
        data_export = {
          date: this.form_search.dates4,
        };
      } else if (st == 5) {
        this.chk_export5 = true;
        url_report = "report/uefi";
        data_export = {
          date: this.form_search.dates5,
        };
      } else if (st == 6) {
        this.chk_export6 = true;
        url_report = "report/claimed-pha";
        data_export = {
          date: this.form_search.dates6,
        };
      } else if (st == 7) {
        this.chk_export7 = true;
        url_report = "quote/report";
        data_export = {
          date: this.form_quote.date,
          type: this.form_quote.type,
        };
      } else if (st == 8) {
        this.chk_export8 = true;
        url_report = "ce-return/report";
        data_export = {
          loan_date: this.loan.date,
          loan_status: this.loan.type,
        };
      }
      // console.log(st, "-status_type")
      // console.log(url_report, '-url_report')
      // console.log(data_export, "-data_send");

      await axios({
        url: url + url_report,
        method: "POST",
        responseType: "blob",
        data: data_export,
        headers: { Authorization: "Bearer " + localStorage.token },
      }).then((response) => {
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "report.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
        if (st == 1) {
          this.chk_export = false;
        } else if (st == 2) {
          this.chk_export2 = false;
        } else if (st == 3) {
          this.chk_export3 = false;
        } else if (st == 4) {
          this.chk_export4 = false;
        } else if (st == 5) {
          this.chk_export5 = false;
        } else if (st == 6) {
          this.chk_export6 = false;
        } else if (st == 7) {
          this.chk_export7 = false;
        }else if (st == 8) {
          this.chk_export8 = false;
        }
      });
    },

    change_date_type() {
      if (
        this.form_search.date_type === "pending" &&
        this.form_search.dates.length != 0
      ) {
        this.form_search.dates = [];
      }
    },
    refresh_data(st) {
      if (st == 1) {
        this.form_search.date_type = null;
        this.form_search.dates = [];
        this.form_search.project = [];
        this.form_search.zone = [];
        this.form_search.sub_type = null;
        this.form_search.layout = "raw";
      } else if (st == 2) {
        this.form_search.caseid = null;
      } else if (st == 3) {
        this.form_odem.date = null;
        this.form_odem.type = null;
      } else if (st == 4) {
        this.form_search.dates4 = [];
      } else if (st == 5) {
        this.form_search.dates5 = [];
      } else if (st == 6) {
        this.form_search.dates6 = [];
      } else if (st == 7) {
        this.form_quote.date = [];
        this.form_quote.type = "";
      } else if (st == 8) {
        this.loan.date = [];
        this.loan.type = null;
      }
    },

},

  data() {
    return {
      chk_export: false,
      chk_export2: false,
      chk_export3: false,
      chk_export4: false,
      chk_export5: false,
      chk_export6: false,
      chk_export7: false,
      chk_export8: false,

      tk: null,
      data_filter: {
        project: [],
        zone: [],
        team: [],
      },
      modal: false,
      modal4: false,
      modal5: false,
      modal6: false,
      modal7: false,
      modal8: false,
      form_search: {
        date_type: null,
        dates: [],
        project: [],
        zone: [],
        team: [],
        sub_type: null,
        layout: "raw",
        dates4: [],
        dates5: [],
        dates6: [],
      },
      form_quote: {
        date: [],
        type: "",
      },
      modal_odm: false,
      form_odem: {
        date: null,
        type: null,
      },
      date_type: ["date open", "date onsite", "date close", "pending"],
      valid: false,
      valid2: false,
      valid3: false,
      valid4: false,
      valid5: false,
      valid6: false,
      date_typeR: [(v) => !!v || "Date Type  is required"],
      date_odmR: [(v) => !!v || "Date Type  is required"],
      typeR: [(v) => !!v || "Date Type  is required"],
      dateR: [(v) => !!v || "Dates  is required"],
      sub_typeR: [(v) => !!v || "Sub Type  is required"],
      caseidR: [(v) => !!v || "Case ID  is required"],
      option_loanR: [(v) => !!v || "Status is required"],
      team_name: localStorage.team_name,
      role_name: localStorage.role_name,
      tk_name: localStorage.fullname,
      emp_id: localStorage.emp_img,
      type: [
        {
          id: 1,
          name: "11.00 - 16.00",
        },
        {
          id: 2,
          name: "8.00 - 11.00 + 16.00",
        },
      ],
      // -----------------------------------------------------------------------
      items_loan: [
         'ไม่มีเคส',
          'loan มีเคส ยังไม่คืน part'
        ],
      loan:{
        data:[], 
        loan_validate:false,
        date_type:null,
        date:[],
        status:null,
      },
     
      
      landscape: true,
    };
  },
};
</script>
